<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card-text class="pt-1">
             <v-row class="mb-5">
                <v-flex xs12>
                  <v-card class="pa-2 rounded-xl" outlined elevation="4" style="background-color: #f8f9fa;">
                    <div class="d-flex flex-column align-end">
                      <v-radio-group 
                        v-model="localOfficialType" 
                        row 
                        class="justify-center d-flex mb-2"
                        :disabled="official_type === 'official' && String(user.id) !== '75'"
                      >
                        <v-radio label="رسمی" value="official"></v-radio>
                        <v-radio label="غیر رسمی" value="unofficial"></v-radio>
                        <v-radio 
                          v-if="official_type === 'pending' || localOfficialType === 'pending'"
                          label="در انتظار تعیین وضعیت" 
                          value="pending"
                        ></v-radio>
                      </v-radio-group>
                      
                      <v-btn 
                        v-if="String(user.id) === '75' || official_type !== 'official'"
                        class="btn-get-code rounded-lg" 
                        :disabled="localOfficialType === official_type && String(user.id) !== '75'"
                        @click="updateOfficialType(localOfficialType)"
                      >
                        <v-icon class="mx-2">mdi-content-save</v-icon>
                        ثبت وضعیت
                      </v-btn>
                    </div>
                  </v-card>
                </v-flex>
              </v-row>

              <v-row
                class="justify-center justify-content-center align-content-center"
              >
                <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                  <v-row>
                    <v-col>
                      <v-radio-group v-model="row" row>
                        <v-radio
                          v-can="'adminDeposit_access'"
                          label="واریز"
                          value="deposit"
                        ></v-radio>
                        <v-radio
                          v-can="'adminWithdraw_access'"
                          label="برداشت"
                          value="withdraw"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col>
                      <v-chip class="ma-2" color="primary" label>
                        ترمینال:

                        {{ price(pricee) }} ریال
                      </v-chip>

                      <v-chip
                        v-can="'admin_operator_wallet'"
                        class="ma-2"
                        color="primary"
                        label
                      >
                        پیامک زنده:

                        {{ price(payamakPrice) }} ریال
                      </v-chip>

                      <v-chip
                        v-can="'admin_real_estate_wallet'"
                        class="ma-2"
                        color="primary"
                        label
                      >
                        تازه های دیوار:

                        {{ price(statePrice) }} ریال
                      </v-chip>
                    </v-col>

                    <v-col>
                      <v-radio-group v-model="service" row>
                        <v-radio
                          v-can="'adminDeposit_access'"
                          label="ترمینال جدید"
                          value="newcore"
                        ></v-radio>
                        <!--                                                <v-radio-->
                        <!--                                                        v-can="'adminDeposit_access'"-->
                        <!--                                                        label="ترمینال"-->
                        <!--                                                        value="newcore"-->
                        <!--                                                ></v-radio>-->
                        <v-radio
                          v-can="'admin_operator_wallet'"
                          label="پیامک زنده"
                          value="payamak"
                        ></v-radio>

                        <v-radio
                          v-can="'admin_real_estate_wallet'"
                          label="تازه های دیوار"
                          value="state"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-row>

              <v-row>
                <v-flex xs12 sm12 md12 lg12 xl4 class="p-2">
                  <price-input
                    :dense="true"
                    :label="'قیمت'"
                    v-model="transferAmount"
                  ></price-input>
                </v-flex>
              </v-row>

              <v-row class="justify-content-center py-3 text-center px-10">
                <v-flex
                  class="p-2"
                  v-for="(cost, index) in costsDefault"
                  :key="index"
                >
                  <v-btn
                    @click="prices(cost.val)"
                    class=" charge btn-buy mx-3  btn-dec-with-text"
                    :id="cost.val"
                    :data-price="cost.val * 10000"
                    :key="index"
                  >
                    <v-icon small class="mx-2"> mdi-plus-circle </v-icon>
                    <span>{{ cost.val | numericPersianNumber }}</span>
                    <span class=" pr-1">ریـال</span>
                    <!--                                  {{ cost.val | numericPersianNumber}}-->
                  </v-btn>
                </v-flex>
              </v-row>

              <v-row class="justify-content-center py-3 text-center px-10">
                <v-flex>
                  <h4 class="mb-1">
                    لطفا علت واریز یا برداشت را در کادر زیر بنویسید.
                  </h4>
                  <v-textarea
                    class="m-1"
                    outlined
                    name="input-7-4"
                    label="توضیحات"
                    v-model="description"
                    :rules="rules.address"
                  ></v-textarea>
                </v-flex>
              </v-row>
              <v-row class="width-100 can" flat>
                <v-card class="px-8 can" flat>
                  <slot name="default" class="can">
                    <v-card-text>
                      <v-file-input
                        ref="fileInput"
                        v-model="filesModel"
                        :loading="upLoading"
                        accept="image/png,image/jpeg"
                        class="d-none"
                        clearable
                        dense
                        hint="حداکثر حجم هر فایل مورد نظر می‌تواند 2 مگابایت باشد."
                        outlined
                        truncate-length="7"
                        @change="handleFileUpload"
                        @click:clear="filesModel = null"
                      />
                    </v-card-text>

                    <v-card
                      id="uploader"
                      ref="uploader"
                      class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
                      height="150"
                      max-width="100%"
                      outlined
                      @click="dragEvent"
                      @dragleave="dragEvent"
                      @dragover="dragEvent"
                      @drop="dragEvent"
                      style="padding: 0px; margin: 0px"
                    >
                      <v-icon size="57" style="opacity: 0.5"
                        >mdi-cloud-upload-outline</v-icon
                      >
                      <v-card-title class="justify-center"
                        >آپلود تصویر واریزی
                      </v-card-title>
                      <v-card-text class="text-center pt-0">
                        برای آپلود تصویر واریزی تصویر را بکشید و رها کنید یا
                        <v-btn
                          class="mx-1"
                          color="primary"
                          min-width="75"
                          small
                        >
                          اینجا
                        </v-btn>
                        کلیک کنید
                      </v-card-text>
                    </v-card>

                    <v-card
                      class="d-flex flex-wrap mx-auto pa-2"
                      flat
                      max-width="700"
                    >
                      <div
                        v-if="filesPreview.length > 0"
                        class="pa-1 text-center d-flex justify-space-between flex-column"
                        style="max-width: 100px; width: 100px"
                      >
                        <div>
                          <v-img
                            :src="filesPreview[0].url"
                            aspect-ratio="1"
                            class="rounded-lg"
                            width="100%"
                          >
                            <div
                              v-if="
                                !upLoading &&
                                (!filesPreview.status || !filesPreview.color)
                              "
                              class="text-left fill-height"
                            >
                              <v-btn icon @click="removeFileFromUpload()">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </div>

                            <div
                              v-else-if="
                                upLoading && filesPreview.status === 'loading'
                              "
                              class="d-flex justify-center align-center fill-height"
                              style="background: rgba(0, 0, 0, 0.5)"
                            >
                              <v-progress-circular
                                color="white"
                                indeterminate
                                size="40"
                                width="5"
                              />
                            </div>

                            <v-card
                              v-else-if="!!filesPreview.color"
                              class="d-flex align-center justify-center"
                              color="rgba(0, 0, 0, .5)"
                              flat
                              height="100%"
                              width="100%"
                            >
                              <v-avatar :color="filesPreview.color">
                                <v-icon
                                  >mdi-{{
                                    !!filesPreview.status ? "check" : "close"
                                  }}</v-icon
                                >
                              </v-avatar>
                            </v-card>
                          </v-img>
                        </div>
                        <span class="mt-1">{{ filesPreview.name }}</span>
                      </div>
                    </v-card>
                  </slot>
                </v-card>
              </v-row>
            </v-card-text>

            <v-card-title>
              <v-btn
                @click="transfer"
                :loading="loading"
                style="width: 100%"
                class="btn-update"
              >
                <v-icon>mdi-bank-transfer</v-icon>
                انتقال
              </v-btn>
              <!--                            <v-card elevation="2" outlined>-->
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import JwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import RolePicker from "@/view/pages/pickers/rolePicker";
import PriceInput from "@/view/pages/pickers/priceInput";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import { mapGetters } from "vuex";
export default {
  name: "walletEdit",
  components: { RolePicker, PriceInput },
  props: ["id"],
  computed:{
    ...mapGetters("ribbon", ["user"]),

  },
  data() {
    return {
       official_type: "pending", 
      localOfficialType: "pending", 
      rawBalance: null,
      upLoading: false,
      filesModel: null,
      filesPreview: [],
      categoryName: "",
      name: null,
      email: null,
      loading: false,
      phone: null,
      role: null,
      rules: {
        text: [(v) => !!(v ?? "").trim() || "لطفا مقداری وارد کنید."],
        mosabatMokhalefSefr: [
          (v) =>
            Math.sign(v) === 1 || "مقدار وارد شده باید عدد و بزرگتر از 0 باشد.",
        ],
        address: [
          (v) =>
            !((v ?? "").length < 4 || (v ?? "").length > 5000) ||
            "مقدار وارد شده باید بزرگتر از 4 کاراکتر و حد اکثر 5 هزار کاراکتر باشد",
        ],
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      description: null,
      pricee: null,
      rerender: true,
      statePrice: null,
      payamakPrice: null,
      transferAmount: 0,
      roles: null,
      walletData: null,
      username: null,
      password: "",
      row: null,
      service: "",
      costsDefault: [
        {
          val: 500_000,
          class: "btn-2000000",
        },
        {
          val: 2_000_000,
          class: "btn-1000000",
        },
        {
          val: 5_000_000,
          class: "btn-3000000",
        },
        {
          val: 10_000_000,
          class: "btn-10000000",
        },
      ],
    };
  },
  watch:{
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
     this.official_type = this.$route.query.official_type || "pending";
    this.localOfficialType = this.official_type;

    this.getWallet();
  },
  methods: {
    updateOfficialType(newVal) {
  const isSuperAdmin = String(this.user.id) === '75';

  if (this.official_type === 'official') {
    if (!isSuperAdmin) {
      this.$toast.error("شما دسترسی تغییر وضعیت حساب‌های تایید شده را ندارید.");
      this.localOfficialType = this.official_type; // برگرداندن UI به حالت قبل
      return;
    } else {
      this.$toast.warning("توجه: شما در حال تغییر وضعیت یک حساب تایید شده (Official) هستید.");
    }
  }

  if (newVal === 'official') {
    const numericBalance = Number(this.rawBalance);
    // if (this.rawBalance === null || isNaN(numericBalance) || numericBalance !== 0) {
    //   this.$toast.error("برای تایید رسمی کاربر، موجودی کیف پول باید دقیقا صفر باشد.");
    //   this.localOfficialType = this.official_type;
    //   return;
    // }
  }
  this.$modal.showLoading();
  
  this.requestApiPost('admin/user/updateOfficialType', { 
    user_id: this.id, 
    official_type: newVal 
  })
    .then(({ data }) => {
      this.$toast.success("وضعیت کاربر با موفقیت به‌روزرسانی شد.");
      
      this.official_type = newVal; 
      this.localOfficialType = newVal;       
      this.$router.replace({ 
        query: { ...this.$route.query, official_type: newVal } 
      }).catch(err => {});       
      this.$modal.hideLoading();
    })
    .catch((error) => {
      this.$modal.hideLoading();      
      const errorMessage = error.response?.data?.message || "خطای در برقراری ارتباط با سرور رخ داد.";
      this.$toast.error(errorMessage);
      this.localOfficialType = this.official_type;
    });
    },
    handleFileUpload(file) {
      if (!file) {
        this.filesPreview = [];
        return;
      }

      if (!file.type.match("image.*")) {
        this.$toast.error("فقط فایل‌های تصویری مجاز هستند.");
        this.filesModel = null;
        return;
      }

      if (file.size > 2000000) {
        this.$toast.error("حداکثر حجم فایل می‌تواند 2 مگابایت باشد.");
        this.filesModel = null;
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.filesPreview = [
          {
            url: e.target.result,
            name: file.name,
          },
        ];
      };
      reader.readAsDataURL(file);

      this.$forceUpdate();
    },
    // async uploadFiles(name = this.categoryName) {
    //   for (const file of this.filesModel) {
    //     await this.uploadToServer(file, name);
    //   }
    // },
    // clearUpload() {
    //   this.filesModel = null;
    //   this.filesPreview = [];
    //   this.categoryName = this.defaultCatName || "";
    // },
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;
      if (
        e.type === "dragover" &&
        !uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.add("drag-over");
      else if (
        e.type === "dragleave" &&
        uploader.$el.classList.contains("drag-over")
      )
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.dataTransfer.files;
        if (files.length > 0) {
          this.filesModel = files[0]; // فقط اولین فایل
          this.handleFileUpload(this.filesModel);
        }
      } else if (e.type === "click") {
        this.$refs.fileInput.$refs.input.click();
      }
    },
    removeFileFromUpload() {
      this.filesModel = null;
      this.filesPreview = [];
    },
    async uploadToServer(file, id) {
      const formData = new FormData();
      this.upLoading = true;

      formData.append("image", file);
      formData.append("transaction_id", id);

      try {
        this.filesPreview[0].status = "loading";

        await axios.post(`${this.$coreApi2}/newWallet/add/image`, formData, {
          headers: {
            Authorization: JwtService.getToken()
              ? `Bearer ${JwtService.getToken()}`
              : null,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        });
        this.filesPreview[0].status = true;
        this.filesPreview[0].color = "success";
        this.filesModel = null;
        this.filesPreview = [];
        this.$toast.success("با موفقیت آپلود شد.");
      } catch (error) {
        this.filesPreview[0].status = false;
        this.filesPreview[0].color = "error";
        this.$toast.error("خطای آپلود تصویر!");
      } finally {
        this.upLoading = false;
      }
    },
    prices(val) {
      this.transferAmount += val;
    },
    getWallet() {
      this.$modal.showLoading();
      this.requestApiGet("newWallet/userWallet", { userId: this.id })
        .then(({ data }) => {
          if (data.data.balance >= 0) {
            this.rawBalance = Number(data.data.balance);
            this.pricee =
              data.data.balance !== null
                ? this.persianNum(
                    this.currency(Math.floor(data.data.balance.toString()))
                  )
                : "ساخته نشده";
          } else {
            this.rawBalance = data.data.balance.$numberDecimal !== undefined
              ? Number(data.data.balance.$numberDecimal)
              : 0;

            this.pricee =
              data.data.balance.$numberDecimal !== undefined
                ? this.persianNum(
                    this.currency(
                      Math.floor(data.data.balance.$numberDecimal.toString())
                    )
                  )
                : "ساخته نشده";
          }
          this.$modal.hideLoading();
        })
        .catch(({ res }) => {
          this.$modal.hideLoading();
          this.$toast.error("خطا در دریافت کیف پول ترمینال");
        });

      this.$modal.showLoading();
      this.requestApiPostPayamak("wallet/admin/balance", { user_id: this.id })
        .then(({ data }) => {
          this.payamakPrice = data.data.balance !== null 
          ? this.persianNum(this.currency(Math.floor(data.data.balance.toString()))) 
          : "0";
          this.$modal.hideLoading();
        })
        .catch((error) => {
          this.$modal.hideLoading();
        });

      this.$modal.showLoading();
      this.requestApiPostState("user/wallet/admin/balance", {
        user_id: this.id,
      })
        .then(({ data }) => {
          this.statePrice = data.data.balance !== null 
            ? this.persianNum(this.currency(Math.floor(data.data.balance.toString()))) 
            : "0";
          this.$modal.hideLoading();
        })
        .catch((error) => {
          this.$modal.hideLoading();
        });
    },
    transfer() {
      if (this.row == null) {
        return this.$toast.error("لطفا نوع عملیات را مشخص کنید.");
      }

      if (this.transferAmount == null || this.transferAmount === 0) {
        return this.$toast.error("لطفا مبلغ انتقال را مشخص کنید.");
      }
      if (!this.description) {
        return this.$toast.error("لطفا علت انجام تراکنش  را بنویسید.");
      }
      if (this.service == null) {
        return this.$toast.error("لطفا سرویس مربوطه را انتخاب کنید.");
      }

      if (this.service == "core") {
        this.$modal.showLoading();
        this.requestApiPost(`admin/wallet/transfer`, {
          to: this.row === "deposit" ? 1 : this.id, //baraye variz az kife pule karbare shomare 1 pul kam mishe be karbar ezaf mishe
          from: this.row === "deposit" ? this.id : 1, //baraye bardasht az kife pule karbar pul kam mishe be kife pule admin ezaf mishe
          amount: this.transferAmount.toString().replace(/,/g, ""),
          description: this.description,
        })
          .then(({ data }) => {
            this.getWallet();
            this.$toast.success("کیف پول کاربر با موفقیت ویرایش شد.");
            this.$modal.hideLoading();
            // this.$router.push({name: 'users'})
          })
          .catch(({ res }) => {
            this.$modal.hideLoading();
            this.loading = false;
            this.$toast.error(res.data.message);
          });
      } else if (this.service == "newcore") {
        this.$modal.showLoading();
        this.requestApiPostWallet(`transactions/transfer`, {
          type: this.row,
          UserId: this.id,
          amount: this.transferAmount.toString().replace(/,/g, ""),
          description: this.description,
        })
          .then(({ data }) => {
            this.getWallet();

            if (this.filesModel !== null && this.filesModel !== undefined) {
              this.uploadToServer(
                this.filesModel,
                data.data.data.transaction.uniqueId
              );
            }
            this.$toast.success("کیف پول کاربر با موفقیت ویرایش شد.");
            this.$modal.hideLoading();
            // this.$router.push({name: 'users'})
          })
          .catch(({ res }) => {
            this.loading = false;
            this.$modal.hideLoading();
            this.$toast.error(res.data.message);
          });
      } else if (this.service == "payamak") {
        this.$modal.showLoading();
        this.requestApiPostPayamak(`wallet/manage`, {
          user_id: this.id,
          amount:
            this.row === "deposit"
              ? this.transferAmount.toString().replace(/,/g, "")
              : this.transferAmount.toString().replace(/,/g, "") * -1,
          description: this.description,
        })
          .then(({ data }) => {
            this.getWallet();
            this.$toast.success("کیف پول کاربر با موفقیت ویرایش شد.");
            this.$modal.hideLoading();
            // this.$router.push({name: 'users'})
          })
          .catch(({ res }) => {
            this.loading = false;
            this.$modal.hideLoading();
            this.$toast.error(res.data.message);
          });
      } else if (this.service == "state") {
        this.$modal.showLoading();
        this.requestApiPostState(`user/wallet/manage`, {
          user_id: this.id,
          amount:
            this.row === "deposit"
              ? this.transferAmount.toString().replace(/,/g, "")
              : this.transferAmount.toString().replace(/,/g, "") * -1,
          description: this.description,
        })
          .then(({ data }) => {
            this.getWallet();
            this.$toast.success("کیف پول کاربر با موفقیت ویرایش شد.");
            this.$modal.hideLoading();
            // this.$router.push({name: 'users'})
          })
          .catch(({ res }) => {
            this.loading = false;
            this.$modal.hideLoading();
            this.$toast.error(res.data.message);
          });
      }
    },
  },
};
</script>

<style scoped>
.activeGateWay {
  border-radius: 1rem !important;
  border: #0d8ddc solid 5px !important;
}

.btn-1000000,
.btn-2000000,
.btn-3000000,
.btn-5000000,
.btn-10000000 {
  border-radius: 5px !important;
  display: block;
  margin: 10px;
  padding: 15px 60px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.7s !important;
  font-weight: bold !important;
  background-size: 200% auto;
}

.btn-1000000:hover,
.btn-2000000:hover,
.btn-3000000:hover,
.btn-5000000:hover,
.btn-10000000:hover {
  background-position: right center;
  color: #fff !important;
  font-weight: bold !important;
  fill: #fff !important;
  text-decoration: none !important;
  border: none !important;
  transition: 0.7s !important;
  box-shadow: 0 0 20px #eee;
}

.btn-1000000 {
  border: 1px solid #44b5ef !important;
  color: #44b5ef !important;
}

.btn-1000000:hover {
  background-image: linear-gradient(
    to right,
    #44b5ef 0,
    #088ed8 51%,
    #44b5ef 100%
  );
}

.btn-1000000-hover {
  background-image: linear-gradient(
    to right,
    #44b5ef 0,
    #088ed8 51%,
    #44b5ef 100%
  );
}

.btn-2000000 {
  border: 1px solid #ef022a !important;
  color: #ef022a !important;
}

.btn-2000000:hover {
  background-image: linear-gradient(
    to right,
    #ef022a 0,
    #f1809c 51%,
    #ef022a 100%
  );
}

.btn-2000000-hover {
  background-image: linear-gradient(
    to right,
    #ef022a 0,
    #f1809c 51%,
    #ef022a 100%
  );
}

.btn-3000000 {
  border: 1px solid #2990ff !important;
  color: #2990ff !important;
}

.btn-3000000:hover {
  background-image: linear-gradient(
    to right,
    #2990ff 0,
    #0067d6 51%,
    #2990ff 100%
  );
}

.btn-3000000-hover {
  background-image: linear-gradient(
    to right,
    #2990ff 0,
    #0067d6 51%,
    #2990ff 100%
  );
}

.btn-5000000 {
  border: 1px solid #29d155 !important;
  color: #29d155 !important;
}

.btn-5000000:hover {
  background-image: linear-gradient(
    to right,
    #29d155 0,
    #1b8d39 51%,
    #29d155 100%
  );
}

.btn-5000000-hover {
  background-image: linear-gradient(
    to right,
    #29d155 0,
    #1b8d39 51%,
    #29d155 100%
  );
}

.btn-10000000 {
  border: 1px solid rgb(150, 85, 0) !important;
  color: rgb(150, 85, 0) !important;
}

.btn-10000000:hover {
  background-image: linear-gradient(
    to right,
    rgb(150, 85, 0) 0%,
    rgb(255, 204, 0) 51%,
    rgb(150, 85, 0) 100%
  );
  color: #fff !important;
  font-weight: bold !important;
}

.btn-10000000-hover {
  background-image: linear-gradient(
    to right,
    rgb(150, 85, 0) 0%,
    rgb(255, 204, 0) 51%,
    rgb(150, 85, 0) 100%
  );
}

.btn-charge-wallet-hover {
  background-image: linear-gradient(
    to right,
    rgba(2, 191, 180, 1) 0%,
    rgba(171, 0, 255, 1) 51%,
    rgba(2, 191, 180, 1) 100%
  );
}

.btn-1000000-hover,
.btn-2000000-hover,
.btn-3000000-hover,
.btn-5000000-hover,
.btn-10000000-hover,
.btn-charge-wallet-hover {
  background-position: right center;
  color: #fff !important;
  font-weight: bold !important;
  fill: #fff !important;
  text-decoration: none !important;
  border: none !important;
  transition: 0.7s !important;
  box-shadow: 0 0 20px #eee;
}
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
}

#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #797979 !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}

@media screen and (max-width: 600px) {
  .v-card >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
}
.can {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
  margin: 0px !important;
}
</style>
